import { Grid, makeStyles } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import RightArrowIcon from 'components/CopilotControl/icons/RightArrowIcon'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ComingSoon from './ComingSoon'
import EngagementWidgetSkeleton from './EngagementWidgetSkeleton'
import ScoreOption from './ScoreOption'
import ScoresBar from './ScoresBar'
import ScoresLegend from './ScoresLegend'
import useEngagementsWidget from './useEngagementsWidget'

const useStyles = makeStyles(theme => ({
  root: props => ({
    alignItems: 'center',
    height: '100%',
    padding: 15,
    paddingBottom: 0,
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      padding: 15,
      paddingBottom: 0
    },
    [theme.breakpoints.up('md')]: {
      padding: 15,
      paddingBottom: 0
    },
    [theme.breakpoints.up('lg')]: {
      padding: 25,
      paddingBottom: 0
    },
    [theme.breakpoints.up('xl')]: {
      padding: 25,
      paddingBottom: 0
    }
  }),
  titleContainer: {
    height: '20%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dataContainer: {
    flex: 1,
    maxWidth: 350,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  scoresBarContainer: {
    width: '80%'
  },
  description: {
    color: '#727B8C',
    padding: '0px 0px'
  },
  legend: {},
  summary: {
    padding: '0px 10px',
    marginTop: 10
  },
  hoverFooter: {
    height: 50,
    position: 'absolute',
    padding: '0 13px',
    background: 'white',
    width: '100%',
    boxShadow: '0px -10px 10px 5px white',
    right: 0,
    bottom: 0,
    display: 'flex',
    zIndex: 2,
    transition: 'opacity 0.5s',
    opacity: 1,
    pointerEvents: 'auto',
    cursor: 'pointer'
  },
  hoverFooterHidden: {
    opacity: 0,
    height: 50,
    pointerEvents: 'none'
  }
}))

const EngagementWidget = ({
  title,
  engagementType,
  values = {},
  isLoading,
  comingSoon = false,
  onChangePatientsListType = () => {}
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [hovered, setHovered] = useState(false)

  const { scoreOptions, averageScoreType, summaryTextOptions } = useEngagementsWidget({
    engagementType,
    values
  })

  return (
    <div
      style={{ position: 'relative', height: '100%', overflow: 'hidden' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {isLoading ? (
        <EngagementWidgetSkeleton />
      ) : comingSoon ? (
        <ComingSoon title={title} />
      ) : (
        <Grid container direction="column" className={classes.root}>
          <Grid item className={classes.titleContainer}>
            <DazzedHeadingForGrid regular xs={14} sm={14} md={14} lg={16} xl={16}>
              {title}
            </DazzedHeadingForGrid>
          </Grid>
          <Grid container className={classes.dataContainer}>
            <Grid item container justifyContent="space-evenly">
              {Object.values(scoreOptions).map((option, index) => (
                <ScoreOption
                  icon={option.icon}
                  fillColor={option.fillColor}
                  strokeColor={option.strokeColor}
                  value={option.value}
                  key={index}
                />
              ))}
            </Grid>
            <Grid item className={classes.scoresBarContainer}>
              <ScoresBar values={values} scoreOptions={scoreOptions} />
            </Grid>
            <Grid item className={classes.legend}>
              <ScoresLegend scoreOptions={scoreOptions} />
            </Grid>
            <Grid item className={classes.summary}>
              <DazzedHeadingForGrid regular xs={12} sm={12} md={12} lg={14} xl={14} style={{ color: '#727B8C' }}>
                {summaryTextOptions[engagementType][averageScoreType]}
              </DazzedHeadingForGrid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <div
        className={
          hovered && !isLoading && !comingSoon
            ? classes.hoverFooter
            : `${classes.hoverFooter} ${classes.hoverFooterHidden}`
        }
      >
        <IconAndText
          reverse
          icon={<RightArrowIcon />}
          text={
            <DazzedHeadingForGrid bold xs={12} sm={12} md={12} lg={14} xl={14} style={{ color: '#3C52EF' }}>
              {t('pages.copilotControl.widgets.engagementWidget.seePatients')}
            </DazzedHeadingForGrid>
          }
          onClick={() => onChangePatientsListType(engagementType)}
        />
      </div>
    </div>
  )
}

export default EngagementWidget
